import {post} from '@/utils/request'

/**
 * 微信小程序审核状态
 * @param id id
 * @param applying 是否审核状态 0 1
 * @returns {AxiosPromise<any>}
 */
export default function admin_plugin_wxapp_apply(id, applying) {
  return post('admin_plugin_wxapp_apply', { id, applying })
}
